/**
 * Grid capacity figures, sourced from PEIEC and Maritime Electric filings. They
 * live here rather than with the frontend constants because the report computes
 * headroom against them on the server while the gauges display them in the
 * browser — a headroom figure must never be measured against a different
 * capacity than the one the reader is shown.
 *
 * Update only when actual infrastructure changes.
 */

/**
 * Interconnection to New Brunswick. The cables are rated far higher; 300 MW is
 * the limit imposed by New Brunswick-side transmission constraints.
 */
const NB_IMPORT_MAX = 300;

/** Maritime Electric combustion turbines plus Summerside diesel, at nameplate. */
const FOSSIL_FUEL_MAX = 104;

export const CAPACITY = {
  nbImportMax: NB_IMPORT_MAX,
  fossilFuelMax: FOSSIL_FUEL_MAX,
  solarMax: 41, // 31 MW utility-scale (PEIEC 10 MW + Summerside 21 MW) + 10 MW Summerside battery
  windMax: 230, // Installed wind capacity including Eastern Kings wind farm (Jan 2026)
  /**
   * Supply that does not depend on the weather: the interconnection limit plus
   * dispatchable fossil generation. Derived from its parts so the total can
   * never drift away from them.
   */
  reliableCapacity: NB_IMPORT_MAX + FOSSIL_FUEL_MAX,
  peakLoad: 393, // Historical peak load (Feb 2023)
} as const;
